import React, { Component } from 'react'
import {
    Alert,
    Grid,
    Tabs,
    FormControl,
    FormControlLabel,
    Checkbox,
    TextField,
    Select,
    MenuItem,
    FormHelperText,
    RadioGroup,
    Radio,
    Box,
} from '@mui/material'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { Trans } from 'react-i18next'
import ObjectCreatedInfo from '../Elements/ObjectCreatedInfo'
import AdminQuickEditMenu from '@/Components/Elements/AdminQuickEditMenu'
import AppDialog from '@/Components/AppDialog/AppDialog'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
import { FormInputLabel } from '@/Components/Elements/StyledComponents/Input'

class DefDossierLinkForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            defDossier: this.props.defDossier,
            submitting: false,
            errors: false,
            defDossiers: [],
            concerningDisplayItems: [],
            displayPositions: [],
            dossierQueries: [],
            back_link: {
                name: '',
                id: '',
                uuid: '',
            },
            locked: this.props.item?.locked,
            item: this.props.item
                ? {
                      id: this.props.item.id,
                      name: this.props.item.name ? this.props.item.name : '',
                      typeOfLink: this.props.item.type_of_link
                          ? this.props.item.type_of_link
                          : 'select',
                      defDossier: this.props.item.def_dossier_id,
                      cascadeRule: this.props.item.cascade_rule,
                      archiveCascadeRule: this.props.item.archive_cascade_rule,
                      childDefDossier: this.props.item.child_def_dossier_id,
                      obligatory: this.props.item.obligatory,
                      locked: this.props.item.locked,
                      locked_description:
                          this.props.item?.locked_description ?? '',
                      uuid: props.item.uuid,
                      settings:
                          this.props.item.settings &&
                          typeof this.props.item.settings == 'object' &&
                          !Array.isArray(this.props.item.settings)
                              ? this.props.item.settings
                              : {},
                  }
                : {
                      defDossier: this.props.defDossier,
                      typeOfLink: 'select',
                      obligatory: false,
                      settings: {},
                      uuid: props.item?.uuid,
                      childDefDossier: this.props.targetDefDossier
                          ? this.props.targetDefDossier
                          : null,
                  },
            activeTab: 'main',
        }

        this.handleErrors = this.handleErrors.bind(this)
        this.handleSuccess = this.handleSuccess.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleNameChange = this.handleNameChange.bind(this)
        this.handleCheck = this.handleCheck.bind(this)
        this.changeDossierQuery = this.changeDossierQuery.bind(this)
        this.handleSettingsCheck = this.handleSettingsCheck.bind(this)
        this.submitLinkField = this.submitLinkField.bind(this)
        this.getDossierQueriesFormControl =
            this.getDossierQueriesFormControl.bind(this)
    }

    /**
     * @param response
     * @returns {boolean}
     */
    hasFormErrors(response) {
        if (
            response?.response?.status === 400 &&
            response.response.data &&
            response.response.data.errors
        ) {
            return true
        }

        return false
    }

    handleSuccess() {
        this.setState({
            submitting: false,
            item: {},
            errors: false,
        })

        this.props.onSuccess(true)
    }

    handleErrors(response) {
        if (!this.hasFormErrors(response)) {
            this.setState({
                submitting: false,
                errors: {
                    generic: this.props.kedo.t('Something went wrong'),
                },
            })
        }

        this.setState({
            submitting: false,
            errors: response.response.data.errors,
        })
    }

    handleSettingsCheck(event) {
        let item = this.state.item

        if (event.target.name === 'cascade_rule') {
            item.settings[event.target.name] = event.target.value
        } else {
            item.settings[event.target.name] = event.target.checked
        }

        this.setState({ item: item })
    }

    changeDossierQuery(event) {
        let item = this.state.item
        item.settings['limit_output_to_mis_item'] = event.target.value

        this.setState({ item: item })
    }

    handleCheck(event) {
        let item = this.state.item
        item[event.target.name] = event.target.checked
        this.setState({ item: item })
    }

    handleChange(event) {
        let item = this.state.item
        item[event.target.name] = event.target.value
        this.setState({ item: item })
    }

    async submitLinkField() {
        let errors = {}

        if (
            !this.state.item.name ||
            !this.state.item.typeOfLink ||
            !this.state.item.childDefDossier
        ) {
            if (
                this.state.item &&
                (!this.state.item.name || this.state.item.name.length <= 0)
            ) {
                errors['name'] = this.props.kedo.t('This is a required field')
            }
            if (
                this.state.item &&
                (!this.state.item.typeOfLink ||
                    this.state.item.typeOfLink.length <= 0)
            ) {
                errors['typeOfLink'] = this.props.kedo.t(
                    'This is a required field'
                )
            }
            if (
                this.state.item &&
                (!this.state.item.childDefDossier ||
                    this.state.item.childDefDossier.length <= 0)
            ) {
                errors['childDefDossier'] = this.props.kedo.t(
                    'This is a required field'
                )
            }

            this.setState({ errors: errors })
            return
        }

        this.setState({
            submitting: true,
            errors: false,
        })

        if (!this.state.item.locked && this.state.locked) {
            await this.props.kedo
                .api()
                .get(
                    this.props.kedo.api().getDefDossierLinkEndpoint() +
                        '/' +
                        this.state.item.id +
                        '/lock'
                )
        }

        let item = {
            obligatory: this.state.item.obligatory === true,
            name: this.state.item.name,
            typeOfLink: this.state.item.typeOfLink,
            cascadeRule: this.state.item.cascadeRule,
            archiveCascadeRule: this.state.item.archiveCascadeRule,
            defDossier: this.state.defDossier,
            settings: this.state.item.settings,
            childDefDossier: this.state.item.childDefDossier,
            locked: this.state.item.locked,
            locked_description: this.state.item.locked_description,
        }

        if (this.props.item && this.props.item.id) {
            item.id = this.props.item.id
            item.uuid = this.props.item.uuid
        }

        if (item.id) {
            this.props.kedo
                .api()
                .patch(
                    this.props.kedo.api().getDefDossierLinkEndpoint() +
                        '/' +
                        item.id,
                    {
                        obligatory: item.obligatory,
                        cascadeRule: item.cascadeRule,
                        archiveCascadeRule: item.archiveCascadeRule,
                        settings: item.settings,
                        name: item.name,
                        typeOfLink: item.typeOfLink,
                        locked: item.locked,
                    }
                )
                .then((successResponse) => this.handleSuccess())
                .catch((errResponse) => this.handleErrors(errResponse))
        } else {
            item.environment = this.props.kedo.env().getEnvironment().id
            item.defDossier = parseInt(this.state.defDossier)
            item.uuid = this.props.kedo.utils().uuidv4()

            this.props.kedo
                .api()
                .post(this.props.kedo.api().getDefDossierLinkEndpoint(), item)
                .then((successResponse) => this.handleSuccess())
                .catch((errResponse) => this.handleErrors(errResponse))
        }
    }

    fetchConcerningDisplayItems(defFieldLinkId) {
        const kedo = this.props.kedo

        if (this.props?.item?.def_dossier_id) {
            kedo.api()
                .get(kedo.api().getDisplayPositionEndpoint(), {
                    params: { defDossier: this.props.item.def_dossier_id },
                })
                .then((response) => {
                    this.setState({
                        displayPositions: response?.data?.results ?? [],
                    })

                    kedo.api()
                        .get(kedo.api().getDisplayItemEndpoint(), {
                            params: { defFieldLinkId: defFieldLinkId },
                        })
                        .then((response) => {
                            this.setState({
                                concerningDisplayItems:
                                    response?.data?.results ?? [],
                            })
                        })
                })
        }
    }

    fetchDefDossiers() {
        let params = {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 500,
            },
        }
        this.setState({ loading: true })
        this.props.kedo
            .api()
            .getCached(this.props.kedo.api().getDefDossierEndpoint(), params)
            .then((response) => {
                this.setState({
                    defDossiers: response.data.results,
                    loading: false,
                })
            })

        this.props.kedo
            .api()
            .get(
                this.props.kedo
                    .api()
                    .getDefDossierLinkEndpoint(this.props.item.id)
            )
            .then((response) => {
                const { data } = response

                this.setState({
                    item: {
                        ...this.state.item,
                        created_at: data.created_at,
                        created_by: data.created_by,
                        modified_at: data.modified_at,
                        modified_by: data.modified_by,
                    },
                })
            })

        if (this.props.item && this.props.item.back_link_id) {
            this.props.kedo
                .api()
                .get(
                    this.props.kedo
                        .api()
                        .getDefDossierLinkEndpoint(this.props.item.back_link_id)
                )
                .then((response) => {
                    const { data } = response
                    this.setState({ back_link: data })
                })
        }
    }

    getDefDossierName(defDossierId) {
        let defDossier = this.state.defDossiers.find(
            (item) => item.id === parseInt(defDossierId)
        )

        if (!defDossier) {
            return ''
        }

        return defDossier.name_plural
    }

    getDossierQueriesFormControl(defDossier) {
        if (!defDossier) {
            return (
                <Alert severity={'info'}>
                    {this.props.kedo.t('No settings available')}
                </Alert>
            )
        }

        let ddObject = this.props.kedo
            .env()
            .getCurrentEnvironmentDefDossiers()
            .find((item) => item.id === defDossier)

        if (
            !ddObject ||
            !ddObject.dossierqueries ||
            ddObject.dossierqueries.length <= 0
        ) {
            return (
                <Alert severity={'info'}>
                    {this.props.kedo.t('No settings available')}
                </Alert>
            )
        }

        return (
            <FormControl size="small" fullWidth>
                <FormInputLabel id="dossier-query-label">
                    {this.props.kedo.t('Choose an option')}
                </FormInputLabel>
                <Select
                    labelId="dossier-query-label"
                    value={
                        this.state.item.settings &&
                        this.state.item.settings.limit_output_to_mis_item
                            ? this.state.item.settings.limit_output_to_mis_item
                            : ''
                    }
                    onChange={this.changeDossierQuery}
                    size="small"
                    displayEmpty
                >
                    <MenuItem value="">
                        {this.props.kedo.t('Choose an option')}
                    </MenuItem>
                    {ddObject.dossierqueries.map((dossierQuery) => (
                        <MenuItem
                            key={dossierQuery.uuid}
                            value={dossierQuery.uuid}
                        >
                            {this.props.kedo
                                .env()
                                .translateItem(dossierQuery, 'dossierquery')}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        )
    }

    componentDidMount() {
        this.fetchDefDossiers()
        if (this.props?.item?.id) {
            this.fetchConcerningDisplayItems(this.props.item.id)
        }
    }

    handleNameChange(e) {
        let input = e.target.value

        const sanitized = input
            .replace(/\s+/g, '_')
            .replace(/[^a-zA-Z0-9_]/g, '')
            .replace(/_+/g, '_')

        let item = this.state.item
        item['name'] = sanitized
        this.setState({ item: item })
    }

    render() {
        const defDossier = this.getDefDossierName(this.state.item.defDossier)
            ? this.getDefDossierName(this.state.item.defDossier)
            : this.props.kedo.t('Entity')
        const dossier =
            this.state.item &&
            this.state.item.childDefDossier &&
            this.state.item.childDefDossier.length > 0
                ? this.getDefDossierName(this.state.item.childDefDossier)
                : this.props.kedo.t('Dossier').toLowerCase()
        const kedo = this.props.kedo

        return (
            <AppDialog
                aria-labelledby="contained-modal-title-vcenter"
                open
                maxWidth={'lg'}
                fullWidth
                title={
                    <>
                        {this.props.item && this.props.item.id
                            ? kedo.t('Edit') + ': ' + this.props.item.name
                            : kedo.t('Add link')}{' '}
                        {this.props.item ? (
                            <Box
                                component="small"
                                sx={{ color: 'text.disabled' }}
                            >
                                {' '}
                                ({this.props.item.id})
                            </Box>
                        ) : null}
                    </>
                }
                onClose={() => this.props.onClose()}
                headerClose={() => this.props.onClose()}
                contentProps={{ dividers: true, dense: true }}
                actions={
                    <>
                        <StyledButton
                            disabled={this.state.loading}
                            onClick={this.submitLinkField}
                        >
                            {this.state.submitting ? (
                                <LoadingDefault size={'sm'} as={'span'} />
                            ) : (
                                <FontAwesomeIcon icon={faSave} />
                            )}
                            &nbsp; {kedo.t('Save')}
                        </StyledButton>
                        <StyledButton
                            disabled={this.state.loading}
                            onClick={() => this.props.onClose()}
                            color="secondary"
                        >
                            {kedo.t('Cancel')}
                        </StyledButton>
                    </>
                }
            >
                <Grid container>
                    <Grid
                        size={3}
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                        <Tabs
                            value={this.state.activeTab}
                            orientation="vertical"
                            onChange={(event, newValue) =>
                                this.setState((prevState) => ({
                                    ...prevState,
                                    activeTab: newValue,
                                }))
                            }
                            sx={{
                                '& .MuiTabs-indicator': {
                                    display: 'none',
                                },
                            }}
                        >
                            <StyledVerticalTab
                                label={kedo.t('Default')}
                                value="main"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Misc')}
                                value="cascade"
                            />
                            {this.props.item && this.props.item.id ? (
                                <StyledVerticalTab
                                    label={
                                        <>
                                            <span>
                                                {this.props.kedo.t(
                                                    'Display fields'
                                                )}{' '}
                                            </span>
                                            <span
                                                className={'badge badge-info'}
                                            >
                                                {
                                                    this.state
                                                        .concerningDisplayItems
                                                        .length
                                                }
                                            </span>
                                        </>
                                    }
                                    value="displayitems"
                                    sx={{
                                        flexDirection: 'row',
                                        alignItems: 'center',
                                        gap: 1,
                                        width: '100%',
                                        justifyContent: 'space-between',
                                    }}
                                />
                            ) : null}
                            {this.props.item && this.props.item.id ? (
                                <StyledVerticalTab
                                    label={kedo.t('Info')}
                                    value="info"
                                />
                            ) : null}
                            {this.props.item &&
                            this.props.item.id &&
                            this.props.handleDelete ? (
                                <StyledVerticalTab
                                    label={kedo.t('Delete')}
                                    value="delete"
                                />
                            ) : null}
                        </Tabs>
                    </Grid>
                    <Grid size={9}>
                        <TabPanel value={this.state.activeTab} index="main">
                            {this.state.errors &&
                            this.state.errors['generic'] ? (
                                <Alert severity={'error'}>
                                    {kedo.t('Something went wrong')}
                                </Alert>
                            ) : null}
                            <h3>{kedo.t('Generic')}</h3>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel className={'required'}>
                                    {kedo.t('Name')}
                                </FormInputLabel>
                                <TextField
                                    value={this.state.item.name}
                                    name="name"
                                    onChange={this.handleNameChange}
                                    size="small"
                                    InputProps={{
                                        readOnly: this.state.loading,
                                    }}
                                    error={!!this.state.errors?.name}
                                    helperText={this.state.errors?.name || ''}
                                    variant="outlined"
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel className={'required'}>
                                    {kedo.t('Type')}
                                </FormInputLabel>
                                <Select
                                    value={
                                        this.state.item.typeOfLink || 'select'
                                    }
                                    name="typeOfLink"
                                    onChange={this.handleChange}
                                    disabled={this.state.loading}
                                    error={!!this.state.errors?.typeOfLink}
                                    size="small"
                                >
                                    <MenuItem value="select">
                                        {this.props.kedo.t('select')}
                                    </MenuItem>
                                    <MenuItem value="embeddedList">
                                        {this.props.kedo.t('embeddedList')}
                                    </MenuItem>
                                </Select>

                                {this.state.errors?.typeOfLink && (
                                    <FormHelperText error>
                                        {this.state.errors.typeOfLink}
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel className={'required'}>
                                    {kedo.t('Entity')}
                                </FormInputLabel>
                                <Select
                                    name="childDefDossier"
                                    value={
                                        this.state.item.childDefDossier || ''
                                    }
                                    onChange={this.handleChange}
                                    disabled={
                                        this.state.loading ||
                                        (this.props.item && this.props.item.id)
                                    }
                                    error={!!this.state.errors?.childDefDossier}
                                    size="small"
                                    displayEmpty
                                >
                                    <MenuItem value="">
                                        {kedo.t('Choose an option')}
                                    </MenuItem>
                                    {this.state.defDossiers.map((item) => (
                                        <MenuItem key={item.id} value={item.id}>
                                            {kedo
                                                .env()
                                                .translateItem(
                                                    item,
                                                    'defdossier'
                                                )}
                                        </MenuItem>
                                    ))}
                                </Select>

                                {this.state.errors?.childDefDossier && (
                                    <FormHelperText error>
                                        {this.state.errors.childDefDossier}
                                    </FormHelperText>
                                )}
                            </FormControl>
                            <FormControl fullWidth>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={'obligatory'}
                                            checked={this.state.item.obligatory}
                                            onChange={this.handleCheck}
                                            disabled={this.state.loading}
                                            size="small"
                                        />
                                    }
                                    label={kedo.t('Required')}
                                    sx={{
                                        mb: 0,
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={'multiple'}
                                            checked={
                                                this.state.item.settings
                                                    ?.multiple ?? false
                                            }
                                            onChange={this.handleSettingsCheck}
                                            disabled={this.state.loading}
                                            size="small"
                                        />
                                    }
                                    label={kedo.t('Multiselect')}
                                    sx={{
                                        mb: 0,
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        },
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            name={'locked'}
                                            checked={this.state.item.locked}
                                            onChange={this.handleCheck}
                                            disabled={this.state.loading}
                                            size="small"
                                        />
                                    }
                                    label={kedo.t('Lock')}
                                    sx={{
                                        mb: 0,
                                        '& .MuiFormControlLabel-label': {
                                            fontSize: '0.875rem',
                                            color: 'text.primary',
                                        },
                                    }}
                                />
                            </FormControl>
                            {this.state.item.locked && (
                                <FormControl fullWidth>
                                    <FormInputLabel>
                                        {`${kedo.t('Lock')} ${kedo.t(
                                            'Description'
                                        )}`}
                                    </FormInputLabel>
                                    <TextField
                                        value={
                                            this.state.item.locked_description
                                        }
                                        name="locked_description"
                                        onChange={this.handleChange}
                                        multiline
                                        rows={3}
                                        size="small"
                                        variant="outlined"
                                        fullWidth
                                    />
                                </FormControl>
                            )}
                            <hr />
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Limit options on dossier query')}
                                </FormInputLabel>
                                {this.getDossierQueriesFormControl(
                                    this.state.item.childDefDossier
                                )}
                            </FormControl>
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="cascade">
                            <h3>{kedo.t('Dossier options')}</h3>
                            <FormControl
                                component="fieldset"
                                fullWidth
                                margin="normal"
                            >
                                <FormInputLabel component="legend">
                                    <Trans i18nKey="cascade_rule_label" />
                                </FormInputLabel>
                                <RadioGroup
                                    name="cascadeRule"
                                    value={
                                        !this.state.item.cascadeRule ||
                                        this.state.item.cascadeRule.length <= 0
                                            ? 'maintain'
                                            : this.state.item.cascadeRule
                                    }
                                    onChange={this.handleChange}
                                >
                                    <FormControlLabel
                                        value="maintain"
                                        control={
                                            <Radio
                                                size="small"
                                                disabled={this.state.loading}
                                            />
                                        }
                                        label={
                                            <Trans
                                                i18nKey="keep_objects"
                                                dossier={dossier}
                                            >
                                                Keep objects from {{ dossier }}
                                            </Trans>
                                        }
                                        sx={{
                                            mb: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                    />
                                    <FormControlLabel
                                        value="delete"
                                        control={
                                            <Radio
                                                size="small"
                                                disabled={this.state.loading}
                                            />
                                        }
                                        label={
                                            <Trans
                                                i18nKey="delete_objects"
                                                dossier={dossier}
                                            >
                                                Delete objects from{' '}
                                                {{ dossier }}
                                            </Trans>
                                        }
                                        sx={{
                                            mb: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                    />
                                    <FormControlLabel
                                        value="constraint"
                                        control={
                                            <Radio
                                                size="small"
                                                disabled={this.state.loading}
                                            />
                                        }
                                        label={
                                            <Trans
                                                i18nKey="delete_objects_no_associations"
                                                defDossier={defDossier}
                                                dossier={dossier}
                                            >
                                                {{ defDossier }} only delete
                                                objects if there are no
                                                associations from {{ dossier }}
                                            </Trans>
                                        }
                                        sx={{
                                            mb: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                    />
                                </RadioGroup>
                            </FormControl>

                            <hr />

                            <p>
                                <Trans
                                    i18nKey="archive_cascade_rule"
                                    dossier={dossier}
                                >
                                    Specify actions for archiving a dossier,
                                    including linked items {{ dossier }}
                                </Trans>
                            </p>

                            <FormControl
                                component="fieldset"
                                fullWidth
                                margin="normal"
                            >
                                <RadioGroup
                                    name="archiveCascadeRule"
                                    value={
                                        this.state.item.archiveCascadeRule || ''
                                    }
                                    onChange={this.handleChange}
                                >
                                    <FormControlLabel
                                        value=""
                                        control={
                                            <Radio
                                                size="small"
                                                disabled={this.state.loading}
                                            />
                                        }
                                        label="None"
                                        sx={{
                                            mb: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                    />
                                    <FormControlLabel
                                        value="archive"
                                        control={
                                            <Radio
                                                size="small"
                                                disabled={this.state.loading}
                                            />
                                        }
                                        label="archive"
                                        sx={{
                                            mb: 0,
                                            '& .MuiFormControlLabel-label': {
                                                fontSize: '0.875rem',
                                                color: 'text.primary',
                                            },
                                        }}
                                    />
                                </RadioGroup>
                            </FormControl>
                        </TabPanel>
                        {this.props.item && this.props.item.id ? (
                            <TabPanel value={this.state.activeTab} index="info">
                                <h3>{kedo.t('Info')}</h3>
                                <FormControl fullWidth>
                                    <FormInputLabel>
                                        {kedo.t('Link')}
                                    </FormInputLabel>
                                    <ObjectCreatedInfo
                                        item={this.state.item}
                                        kedo={kedo}
                                    />
                                </FormControl>
                                <hr />
                                <FormControl fullWidth margin="normal">
                                    <FormInputLabel>
                                        {kedo.t('Back link')}
                                    </FormInputLabel>
                                    <ObjectCreatedInfo
                                        item={this.state.back_link}
                                        kedo={kedo}
                                    />
                                </FormControl>
                            </TabPanel>
                        ) : null}
                        {this.props.item &&
                            this.props.item.id &&
                            this.props.handleDelete && (
                                <TabPanel
                                    value={this.state.activeTab}
                                    index="delete"
                                >
                                    <h3>{kedo.t('Delete')}</h3>
                                    <Alert severity={'error'}>
                                        {kedo.t(
                                            'Are you sure you want to delete this link?'
                                        )}
                                    </Alert>
                                    <StyledButton
                                        onClick={this.props.handleDelete}
                                        color={'error'}
                                    >
                                        {kedo.t('Delete')}
                                    </StyledButton>
                                </TabPanel>
                            )}
                        {this.props.item && this.props.item.id ? (
                            <TabPanel
                                value={this.state.activeTab}
                                index={'displayitems'}
                            >
                                <Box sx={{ mt: 1 }}>
                                    <table className={'table table-striped'}>
                                        <tr>
                                            <td colSpan={5}>
                                                <h3>
                                                    {kedo.t('Display fields')}
                                                </h3>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>{kedo.t('Id')}</th>
                                            <th>{kedo.t('Name')}</th>
                                            <th>{kedo.t('Position')}</th>
                                            <th>{kedo.t('View')}</th>
                                            <th>{kedo.t('Edit')}</th>
                                        </tr>
                                        {this.state.concerningDisplayItems.map(
                                            (ddiItem) => {
                                                return (
                                                    <tr key={ddiItem.id}>
                                                        <td>{ddiItem.id}</td>
                                                        <td>
                                                            {kedo.translateItem(
                                                                ddiItem,
                                                                'displayitem'
                                                            )}
                                                        </td>
                                                        <td>
                                                            {this.state
                                                                .displayPositions
                                                                .length > 0 &&
                                                                (() => {
                                                                    const pos =
                                                                        this.state.displayPositions.find(
                                                                            (
                                                                                d
                                                                            ) =>
                                                                                d.id ===
                                                                                ddiItem.display_position_id
                                                                        )
                                                                    return pos
                                                                        ? kedo.translateItem(
                                                                              pos,
                                                                              'displayposition'
                                                                          )
                                                                        : null
                                                                })()}
                                                        </td>
                                                        <td>
                                                            {kedo.t(
                                                                ddiItem.view
                                                            )}
                                                        </td>
                                                        <td>
                                                            <AdminQuickEditMenu
                                                                className={
                                                                    'inner-edit'
                                                                }
                                                                kedo={kedo}
                                                                item={ddiItem}
                                                            />
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        )}
                                    </table>
                                </Box>
                            </TabPanel>
                        ) : null}
                    </Grid>
                </Grid>
            </AppDialog>
        )
    }
}

export default DefDossierLinkForm
